import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { SweetAlertHelper } from '../helpers/sweet-alert-helper.service';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { SessionEventService } from './session-event.service';

// declare const firebase: any;
// declare const html2canvas: any;

@Injectable()
export class CustomInterceptorService implements ErrorHandler {
  currentUser = null;
  router: Router;

  coincidenceErrors = [
    'Authorization has been denied for this request.',
    'Uncaught (in promise): FirebaseError: [code=invalid-argument]: Function addDoc()',
    'Error: Uncaught (in promise): FirebaseError: [code=invalid-argument]: Function addDoc()'
  ];

  constructor(private _injector: Injector, private sweetAlertHelper: SweetAlertHelper) {
    this.router = this._injector.get(Router);
  }

  showModalMessage(error: any, customMsj = false, timeExec: number = 2000): void {
    let MSG = '';
    if (customMsj) {
      MSG = 'Authorization has been denied for this request.';
    } else {
      MSG = error._body ? JSON.parse(error._body).message : 'Unknown error. For more information see the error log.';
    }

    setTimeout(() => {
      this.sweetAlertHelper.createCustomAlert({title: 'Unauthorized', text: MSG, type: 'error'});
    }, timeExec);
  }

  verifyNotAuthorizedError(error: Response) {
    // TODO: This could be removed if the .catch(Observable.throw(error.json())) is removed from all HTTP methods.
    if (!(error instanceof Response)) {
      return error;
    }

    if (error.status !== 401) {
      return Observable.throw(error.json());
    }

    const sessionEventService = this._injector.get(SessionEventService);
    sessionEventService.notifySessionExpired();
    const pendingReservation = localStorage.getItem('pendingReservation');
    window.localStorage.clear();
    if (pendingReservation) {
      localStorage.setItem('pendingReservation', pendingReservation);
    }
    this.router.navigate(['/login']);
    this.showModalMessage(error);
  }

  ignoreErrorsForCoincidence(error: any): boolean {
    let result = false;
    try {
      const err = error.stack ? error.stack.toString() : error.message ? error.message.toString() : error.toString();
      if (error) {
        this.coincidenceErrors
        .forEach(element => {
          if (err.toUpperCase().indexOf(element.toUpperCase()) >= 0) {
            result = true;
          }
        });
        return result;
      } else {
        return result = true;
      }
    } catch (error) {
      this.sweetAlertHelper.createCustomAlert({title: 'Error', text: 'ignoreErrorsBackend' + error, type: 'error'});
    }

    return result;
  }

  handleError(error: any) {
    if (this.shouldLogError) {
      console.error(`Error:=>   ${error} `);
    }
    if (environment.firebaseIsAvailable && environment.production && !this.ignoreErrorsForCoincidence(error)) {
      // html2canvas(document.body).then((canvas) => {
      //   const imgData = canvas.toDataURL('image/jpeg', 0.40);
      //   const nameImg = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) + '.jpeg';
      //   const user = JSON.parse(localStorage.getItem('currentUser'));
      //   const hoy = new Date();
      //   const fecha = hoy.getDate() + '-' + (hoy.getMonth() + 1) + '-' + hoy.getFullYear();
      //   const hora = hoy.getHours() + ':' + hoy.getSeconds() + ':' + hoy.getSeconds();
      //   const errorDetalls = {
      //     id: 0,
      //     img: nameImg,
      //     domain: window.location.hostname,
      //     user: user,
      //     error: error.stack ? error.stack.toString() : error.message ? error.message.toString() : error,
      //     date: fecha + ' ' + hora,
      //     ua: navigator.userAgent,
      //     url: window.location.href,
      //     status: 1,
      //     screenshot: imgData,
      //     message: error.message ? error.message : 'Unreturned message property.',
      //     versions: {
      //       local: environment.version,
      //       name_env: environment.name_env,
      //       remote: window.localStorage.getItem('remoteVersion')
      //     }
      //   };
      //   firebase.firestore().collection('DebugLog')
      //   .add(errorDetalls).then((x: any) => {
      //     if (user) {
      //       if (user.usertypeid === 1 && user.roleid === 1) {
      //         // TODO MEJORAR toastr.warning('An error has Occurred!', 'Attention');
      //       }
      //     } else {
      //       this.router.navigate(['/login']);
      //       this.showmodalMessage(error, true);
      //       window.localStorage.clear();
      //     }
      //   });
      // });
    }

    return this.verifyNotAuthorizedError(error);
  }


  get shouldLogError(): boolean {
    const allowedEnvironments = ['dev', 'beta', 'localhost'];
    const currentEnv = environment.name_env.toLowerCase();
    return environment && !environment.production && allowedEnvironments.includes(currentEnv);
  }


}



// WEBPACK FOOTER //
// ./src/app/core/services/custom-interceptor.service.ts